import {isCartStep, formatNumber, getCdnImageUrl} from "../functions";
import {Layout} from "./layout";
import {isLogged, getCustomerGuid} from "../customer";
import * as api from '../api';

var tableRow = function (item) {
	return `<tr class="single-merchandise">
                                    <td class="single-merchandise-info row">
                                       <div class="single-merchandise-foto large-2 medium-3 small-0 columns left">
                                          <a href="#" title="SALVEST Põnn BIO Banán s borůvkou a obilnými vločkami (110 g)">
                                          <img src="${getCdnImageUrl(`/user/shop/related/${item.image}`)}">
                                          </a>
                                       </div>
                                       <div class="single-merchandise-text-info large-10 medium-9 small-12 columns">
                                          <span class="text-wrapper" data-testid="cartProductName">
                                             <a href="${item.url}" class="main-link">${item.name}</a>
                                          </span>
                                       </div>
                                       <div class="clear">&nbsp;</div>
                                    </td>
                                   
                                    <td class="tac">
                                       <div>
                                          <form action="" method="post">
                                             <fieldset>
                                                <div class="relative">
                                                <a href="#" class="add-pcs icon-arrow-up-before" title="Zvýšit množství" data-testid="increase">&nbsp;</a>
                                                <a href="#" class="remove-pcs icon-arrow-down-before" title="Snížit množství" data-testid="decrease">&nbsp;</a>
                                                <span class="show-tooltip add-pcs-tooltip js-add-pcs-tooltip" aria-hidden="true" role="tooltip" data-testid="tooltip"></span>
                                                <span class="show-tooltip remove-pcs-tooltip js-remove-pcs-tooltip" aria-hidden="true" role="tooltip" data-testid="tooltip"></span>
                                                <input type="hidden" name="itemId" value="${item.id}">
                                                <input type="number" name="amount" value="${item.quantity}" class="pcs" data-decimals="0" data-max="9999" data-min="1" step="any" min="1" max="9999" data-testid="cartAmount">
                                                </div>
                                             </fieldset>
                                          </form>
                                       </div>
                                    </td>
                                    <td class="tac mobile-hide" data-testid="cartItemPrice">
                                       ${formatNumber(item.priceWithDiscount)} Kč
                                    </td>
                                    <td class="tac">
                                       <strong class="nowrap" data-testid="cartPrice">${formatNumber(item.priceWithDiscount*item.quantity)} Kč/obj</strong>
                                    </td>
                                    <td class="tac my-cart">
                                       <form action="#" class="sub-delete" method="post">
                                          <fieldset>
                                             <input type="submit" value="x" class=" small button" aria-label="Odstranit z košíku">
                                             <input type="hidden" value="${item.id}" class="item-id" />
                                          </fieldset>
                                       </form>
                                    </td>
                                 </tr>`
}
var childrenTable = function (children) {

	var table = [];
	children.forEach(function (child) {
		var items = [];
		child.items.forEach(function (item) {
			items.push(tableRow(item));
		})

		table.push(`<table style="margin-bottom: 10px">
                              <colgroup>
                                 <col style="width: 50%">
                                 <col class="mobile-hide" style="width: 9%">
                                 <col style="width: 7%">
                                 <col class="mobile-hide" style="width: 12%">
                                 <col style="width: 10%">
                                 <col style="width: 3%">
                              </colgroup>
                              <thead>
                                 <tr>
                                    <th class="tal">
                                       ${child.childName}
                                    </th>
                                    <th class="tac">
                                       Množství
                                    </th>
                                    <th class="tac mobile-hide">
                                       Cena za kus
                                    </th>
                                    <th class="tac">
                                       Součet
                                    </th>
                                    <th>
                                       &nbsp;
                                    </th>
                                 </tr>
                              </thead>
                              <tbody>
                                ${items.join('')}
                              </tbody>
                           </table>`)

	})

	return table.join('');
}

var render = function (cart) {

	if (isLogged()) {
		var responseDeliveryPeriods = api.getData('get-delivery-periods', {}, { async: false }).responseJSON;
		var deliveryPeriods = [];

		responseDeliveryPeriods.forEach(function (row) {
			deliveryPeriods.push(`<option value="${row.amount}" data-days="${row.amount} dní" ${cart.repeat ? 'selected' : ''}>${row.description}</option>`);
		});

		if (!cart.data) {
			return Layout('<p>Předplatné je prázdné, přidejte si něco.</p>', 1)
		}

		if (cart.data.length === 0) {
			return Layout(`<article>
					<h2>Váš předplatný košík je prázdný</h2>
					<p class="empty-cart-msg">
                        <strong class="strong-title">Ale nemusí to tak být</strong>
                    </p></article>`)
		}

		return Layout(`
            <article>
               <div>
                     <div id="cart-wrapper">
                        <div id="cart">
                           ${childrenTable(cart.data)}
                           <div class="tar cart-price-info columns">
                              <em>Ceny jsou uvedeny včetně DPH</em>
                           </div>
                           
                           <div class="clear">&nbsp;</div>
                           
                           <div id="summary" class="vat cart-summary row collapse">
	                              <div id="summary-left" class="large-8 medium-7 small-12 columns">
	                                 <div id="summary-left-wrapper">
	                                    <div class="cart-tip to-free-shipping" style="display: none">
	                                       Objednejte ještě za <strong>1 459,10 Kč</strong> a budete mít dopravu <strong>ZDARMA</strong>.
	                                    </div>
	                                 </div>
	                              </div>
	                              <div id="summary-right" class="large-4 medium-5 small-12 columns">
	                                 <table id="cart-price-summary">
	                                    <tbody>
	                                       <tr>
	                                          <td class="tal">
	                                             <strong class="cart-main-price">Cena vč. DPH:</strong>
	                                          </td>
	                                          <td class="tar" data-testid="recapFullPrice">
	                                             <strong class="cart-main-price cart-order-final-price">${formatNumber(cart.totalPrice)} Kč/obj</strong>
	                                          </td>
	                                       </tr>
	                                       <tr>
	                                          <td class="tal">
	                                             Cena bez DPH:
	                                          </td>
	                                          <td class="tar" data-testid="recapFullPriceNoVat">
	                                           ${formatNumber(cart.totalPriceWithoutVat)} Kč/obj
	                                          </td>
	                                       </tr>
	                                    </tbody>
	                                 </table>
	                              </div>
	                           </div>
	                           <div class="clear">&nbsp;</div>
	                           
	                           <div class="subscription-bonus-program"></div>
                           
                           <form id="subscription-cart">
	                           <table id="additional-stuff-in-cart" class="cart-additional-benefits">
	                              <tr>
	                                 <td class="benefit-name">
	                                 <strong>Kdy budeme zasilku odesílat: </strong>
	                                 <span>Zde si zvolíte kdy chcete aby Vám od nás odcházela Vaše první HomeBox objednávka. Po této objednávce Vám budeme další HomeBox objednávky doručovat podle nastavené frekvence v kroku níže. Pokud zvolíte datum, které náleží na víkend nebo státní svátek, tak tuto objednávku odešleme vždy nejbližší možný pracovní den.</span>
	                              
	                                 </td>
	                                 <td class="benefit-value" id="first-date">
	                                    <input value="${cart.firstDate}" type="date" id="coupon-no" class="cart-additional-coupon" required="required" size="30">
	                                 </td>
	                              </tr>
	                              <tr>
	                                 <td class="benefit-name">
	                                 <strong>Jak často vám budeme odesílat: </strong>
	                                 <span>Objednávku budeme vytvářet každých <strong id="days">(zvolte si ze seznamu)</strong>. Pokud objednávka výjde na víkend či státní svátek tak jí odešleme hned další pracovní den.</span>
	                              
	                                 </td>
	                                 <td class="benefit-value">
	                                    <select class="cart-additional-coupon" id="delivery_period" required="required">
	                                       <option value="" data-days="(ZVOLTE SI ZE SEZNAMU)">--- Vyberte si jak často ---</option>
	                                       ${deliveryPeriods.join('')}
	                                    </select>
	                                 </td>
	                              </tr>
	                              <tr>
	                                 <td class="benefit-name">
	                                 <strong>Chci chytré předplatné: </strong>
	                                 <span>Chytré předplatné je ušité přímo potřebám Vašeho dítěte. Pokud Vaše dítě již dosáhlo věku, kdy je nutné změnit velikost či věkovou řadu mléka, systém tento produkt automaticky změní ve Vaší objednávce. Na tuto změnu Vás systém vždy upozorní předem prostřednictvím emailu a na tuto změnu budete moci zareagovat.</span>
	                              
	                                 </td>
	                                 <td class="benefit-value">
	                                    <select class="cart-additional-coupon" id="smart_subscription" required="required">
	                                       <option value="">--- Vyberte možnost ---</option>
	                                       <option value="1" ${cart.smartSubscription === 1 ? 'selected' : ''}>Ano</option>
	                                       <option value="0" ${cart.smartSubscription === 0 ? 'selected' : ''}>Ne</option>
	                                    </select>
	                                 </td>
	                              </tr>
	                             
	                              </tbody>
	                           </table>
	                           
	                           <div id="additional-information"><p><strong>Co je to chytré předplatné?</strong><span>Chytré předplatné se dokáže přizpůsobit potřebám Vašeho dítěte. Pomůže mu vyplnění věku dítěte ve vašem HomeBoxu. Jak Vaše dítě roste, pokaždé vyžaduje i jiný typ produktů. Pokud je to třeba, systém Vás e-mailem upozorní, že je nutné přejít na jinou věkovou řadu mléka, případně vymění velikost plen za větší. Vždy Vás o takovéto změně informuje a Vy budete mít možnost zareagovat podle svých preferencí.</span></p></div>

	                           
	                           <input type="submit" style="display: none" />
                           </form>
                        </div>
                        <div class="buttons-order buttons-order-cart tar">
                           <span class="continue-shopping">
                           <a href="/" class="back-href">Zpět do obchodu</a>
                           </span>
                           <span class="complete-shopping">
                           <button type="button" title="Zaplatit" class="fr normal button success" id="continue-order-button" data-testid="nextStep">Pokračovat</button>
                           </span>
                        </div>
                        <div class="clear">&nbsp;</div>
                     </div>
               </div>
            </article>`, cart.data.length);
	} else {
		return Layout('<p>Musíte být přihlášen</p>', 1)
	}
}

var loadCart = function () {
	api.getData('get-cart', { guid: getCustomerGuid() }).done(function (cart) {
		$('#main-in').html(render(cart))
		var date = new Date();
		date.setDate(date.getDate() + 1);
		$('#first-date input').attr('min', date.toISOString().split("T")[0]);
		$('#days').text($('#delivery_period').find('option:selected').data('days'));
		hideSpinner();
	});
}

if ($('body').hasClass('in-predplatne') && isCartStep(1)) {
	showSpinner();
	loadCart();
}

$(document).on('submit', '#subscription-cart', function (e) {
	e.preventDefault();
	showSpinner();
	api.patchData('update-cart', {
		date: $(this).find('#coupon-no').val(),
		deliveryPeriod: $(this).find('#delivery_period').val(),
		smartSubscription: $(this).find('#smart_subscription').val()
	}, {
		guid: getCustomerGuid(),
	}).done(function () {
		window.location.href = '?step=2';
	})
})

$(document).on('change', '#delivery_period', function (e) {
	$('#days').text($(this).find('option:selected').data('days'));
});

$(document).on('click', '.in-predplatne #continue-order-button', function (e) {
	e.preventDefault();
	$('#subscription-cart [type="submit"]').click();
})

$(document).on('submit', '.my-cart .sub-delete', function (e) {
	e.preventDefault()
	showSpinner();
	api.deleteData('delete-cart-item', {
		itemId: $(this).find('.item-id').val(),
		guid: getCustomerGuid(),
	}).done(function () {
		loadCart()
	})
})

$(document).on('click', '.in-predplatne .add-pcs, .in-predplatne .remove-pcs', function (e) {
	e.preventDefault();
	e.stopImmediatePropagation();
	var input = $(this).parent().find('.pcs');
	var id = $(this).parent().find('[name="itemId"]').val();
	var value = parseInt(input.val());
	if ($(this).hasClass('add-pcs')) {
		value++;
	} else if(value > 1) {
		value--;
	}
	input.val(value);

	showSpinner();
	api.patchData(
		'update-cart-item-quantity',
		{},
		{ guid: getCustomerGuid(), itemId: id, quantity: value }
		).done(function (data) {
			loadCart();
	});
})

$(document).on('change', '.in-predplatne .pcs', function (e) {
	e.stopImmediatePropagation();
	if($(this).val() <= 0) {
		e.preventDefault();
		alert('Množství musí být více než 0');
		$(this).val($(this).prop("defaultValue"));
		return;
	}
	showSpinner();
	api.patchData(
		'update-cart-item-quantity',
		{},
		{ guid: getCustomerGuid(), itemId: $(this).closest('form').find('[name="itemId"]').val(), quantity: $(this).val() }
	).done(function (data) {
		loadCart();
	});
})

$(document).on('change', '#first-date input', function (e) {
	var day = new Date($(this).val()).getUTCDay();
	if([6,0].includes(day)){
		e.preventDefault();
		this.value = '';
		alert('Zvolte prosím pracovní den. O víkendech neposíláme zboží. Pokud vám předplatné výjde na víkend, odešleme jej nejbližší pracovní den.');
	}
})